import React from "react";

function NewsletterCard() {
  return (
    <div className=" relative cardWidth bg-frescoWhite flex flex-col justify-center  py-6 px-4 space-y-2 rounded-xl ">
      <h3 className="items-start align-baseline text-darkGray font-bold">
        Newsletter{" "}
      </h3>
      <div className="flex space-x-2 justify-between">
        <p className="text-start text-darkGray md:text-xs  text-sm">
          Come ride the Vibehut wave with us. <br /> Subscribe to keep up!
        </p>
        <img
          className=" h-16 w-16 md:h-12 md:w-12"
          src={`${process.env.PUBLIC_URL}/newsletter.png`}
          alt="Subscribe to Vibehut Newsletter"
        />
      </div>
      <iframe
        title="vibehut Newsletter"
        src="https://embeds.beehiiv.com/2513549c-71e9-4fc9-a308-3d36993b3a71?slim=true"
        data-test-id="beehiiv-embed"
        height="52"
        frameBorder="0"
        style={{
          margin: 0,
          borderRadius: "0px",
          backgroundColor: "transparent",
          marginTop: "12px",
          fontSize: "12px",
        }}
      ></iframe>
    </div>
  );
}

export default NewsletterCard;
